<template>
  <div class="p-4 space-y-4">
    <!-- loader -->
    <div v-if="loading" v-loading="loading" style="height: 100px"></div>

    <div v-else class="space-y-3">
      <div
        v-for="channel in channels"
        :key="channel.key"
        :class="['channel-card border border-gray-200 rounded-2xl bg-white shadow-sm overflow-hidden', channel.enabled ? '' : 'channel-card--disabled']"
      >
        <div class="channel-card__title-header px-4 py-2 bg-gray-50 border-b border-gray-200 flex items-center justify-between gap-3">
          <div class="flex items-center gap-3">
            <span class="channel-icon" :style="{ backgroundColor: channel.badgeBg, color: channel.badgeColor }">
              <i :class="channel.iconClass"></i>
            </span>
            <span class="font-semibold text-base text-gray-900">{{ channel.label }}</span>
          </div>
          <el-button
            type="primary"
            size="small"
            :loading="channelSavingStates[channel.key]"
            @click="handleSaveChannelDndSettings(channel)"
          >
            Save Changes
          </el-button>
        </div>

        <div class="channel-card__header px-4 pt-3">
          <div class="flex items-start gap-3">
            <el-switch v-model="channel.enabled" :inline-prompt="true" @change="onToggleChannel(channel)" />
            <div>
              <p class="text-xs text-gray-500">
                {{ channel.description }}
              </p>
            </div>
          </div>
        </div>

        <div class="channel-card__body px-4 pb-3">
          <div class="channel-field">
            <p class="channel-field__label mb-2">Do not disturb timing (User's time zone)</p>
            <div class="flex flex-row flex-wrap gap-6 items-start">
              <div class="time-picker flex flex-col" :class="{ 'time-picker--disabled': !channel.enabled }">
                <p class="time-label mb-1 text-xs text-gray-600">From</p>
                <div class="time-input">
                  <el-select v-model="channel.from.hour" :disabled="!channel.enabled" placeholder="HH" size="small" class="time-select w-20 subtle-select">
                    <el-option v-for="hour in hourOptions" :key="hour" :label="hour" :value="hour" />
                  </el-select>
                  <span class="time-separator">:</span>
                  <el-select v-model="channel.from.minute" :disabled="!channel.enabled" placeholder="MM" size="small" class="time-select w-20 subtle-select">
                    <el-option v-for="minute in minuteOptions" :key="minute" :label="minute" :value="minute" />
                  </el-select>
                  <div class="meridiem-toggle">
                    <button type="button" :disabled="!channel.enabled" :class="['meridiem-btn', channel.from.meridiem === 'am' ? 'is-active' : '']" @click="setMeridiem(channel.from, 'am')">am</button>
                    <button type="button" :disabled="!channel.enabled" :class="['meridiem-btn', channel.from.meridiem === 'pm' ? 'is-active' : '']" @click="setMeridiem(channel.from, 'pm')">pm</button>
                  </div>
                </div>
              </div>
              <div class="time-picker flex flex-col" :class="{ 'time-picker--disabled': !channel.enabled }">
                <p class="time-label mb-1 text-xs text-gray-600">To</p>
                <div class="time-input">
                  <el-select v-model="channel.to.hour" :disabled="!channel.enabled" placeholder="HH" size="small" class="time-select w-20 subtle-select">
                    <el-option v-for="hour in hourOptions" :key="hour" :label="hour" :value="hour" />
                  </el-select>
                  <span class="time-separator">:</span>
                  <el-select v-model="channel.to.minute" :disabled="!channel.enabled" placeholder="MM" size="small" class="time-select w-20 subtle-select">
                    <el-option v-for="minute in minuteOptions" :key="minute" :label="minute" :value="minute" />
                  </el-select>
                  <div class="meridiem-toggle">
                    <button type="button" :disabled="!channel.enabled" :class="['meridiem-btn', channel.to.meridiem === 'am' ? 'is-active' : '']" @click="setMeridiem(channel.to, 'am')">am</button>
                    <button type="button" :disabled="!channel.enabled" :class="['meridiem-btn', channel.to.meridiem === 'pm' ? 'is-active' : '']" @click="setMeridiem(channel.to, 'pm')">pm</button>
                  </div>
                </div>
              </div>
              <div class="flex flex-col ml-8" :class="{ 'opacity-50': !channel.enabled }" style="min-width: 320px;">
                <p class="channel-field__label mb-1 text-xs text-gray-600">Action To Take During DND Hours</p>
                <el-select v-model="channel.action" :disabled="!channel.enabled" placeholder="Select" class="w-full subtle-select">
                  <el-option v-for="action in actionOptions" :key="action.value" :label="action.label" :value="action.value" />
                </el-select>
              </div>
            </div>
            <p class="text-xs text-gray-400 mt-1.5">Messages generated in this window will follow the rule selected for the channel.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DoNotDisturbComponent from './doNotDisturb'
export default DoNotDisturbComponent
</script>
